<template>
	<v-data-table-server
		v-model:options="options"
		:items="items"
		:loading="loading"
		:items-length="totalRows"
		v-bind="$attrs"
		@update:options="index"
	>
		<template
			v-for="(_, slot) of $slots"
			#[slot]="scope"
		>
			<slot
				:name="slot"
				v-bind="scope"
			/>
		</template>
	</v-data-table-server>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import {
	debounce, isEqual,
} from 'lodash';

/**
 *  A table component for presenting elements of a database model (table) to the user
 *  This variant is used for endpoints that handle pagination, sorting and filtering in the backend.
 *  This is useful for tables with a large number of rows.
 */
export default {
	name: 'ModelBackendTable',
	props: {
		/** The indexer endpoint used to retrieve table data */
		endpoint: {
			type: String,
			required: true,
		},

		/** Data filter for table objects */
		filter: {
			type: Object,
			required: false,
			default: null,
		},
	},

	data () {
		return {
			items: [],
			loading: true,
			options: {
			},
			totalRows: 0,
		};
	},

	watch: {
		filter: {
			/**
			 * @param {any} newValue
			 * @param {any} oldValue
			 * @returns {void}
			 */
			handler (newValue, oldValue) {
				if (!isEqual(newValue, oldValue)) {
					debounce(() => {
						this.index();
					}, 300)();
				}
			}
		},

		endpoint () {
			this.options.page = 1;
			this.index();
		}
	},

	mounted () {
		this.index();
	},

	methods: {
		/**
		 * Update the table. Hands all parameters for filtering, pagination and sorting to backend
		 *
		 * @returns {void}
		 */
		index () {
			this.loading = true;
			const params = {
				'page': this.options.page,
				'limit': this.options.itemsPerPage,
			};

			if (this.options.sortBy.length > 0) {
				params.sortBy = this.options.sortBy[0].key ? this.toSnakeCase(this.options.sortBy[0].key) : '';
				params.sortDesc = this.options.sortBy[0].order ? this.options.sortBy[0].order : '';
			}

			if (this.filter !== null) {
				for (const [key, value, ] of Object.entries(this.filter)) {
					if (value != null) {
						params[key] = value;
					}
				}
			}

			axios.get(this.endpoint, {
				params: params
			}).then(({
				data,
			}) => {
				data.result.forEach((item, i) => {
					item.uniqueId = i;
				});
				this.items = data.result;
				this.totalRows = data.count;
				this.loading = false;
			}).catch((error) => {
				window.captureException(error);
				this.loading = false;
			});
		},

		/**
		 * @param {string} string
		 * @returns {string}
		 */
		toSnakeCase (string) {
			return string.split(/ |\B(?=[A-Z])/)
				.map((word) => word.toLowerCase())
				.join('_');
		}
	},
};
</script>
